import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f4f57a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thought-admin-tools-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Announcements", -1 /* HOISTED */))
const _hoisted_3 = { class: "table table-bordered" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Location"),
    /*#__PURE__*/_createElementVNode("th", null, "Copy"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Ending Date "),
      /*#__PURE__*/_createElementVNode("span", { class: "small" }, "(end of day)")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "Remove")
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "announcements-list" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "99",
  style: {"text-align":"center"}
}, " No active announcements ", -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { colspan: "99" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("label", { for: "tl-announcement-add-space" }, "Location:")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("label", { for: "tl-announcement-add-copy" }, "Copy:")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("label", { for: "tl-announcement-add-end-date" }, [
      /*#__PURE__*/_createTextVNode("Ending Date: "),
      /*#__PURE__*/_createElementVNode("span", { class: "small" }, "(end of day)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("th", { colspan: "99" })
], -1 /* HOISTED */))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, " Site Wide ", -1 /* HOISTED */))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "editor" }
const _hoisted_21 = {
  key: 0,
  class: "editor-buttons"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "date" }
const _hoisted_24 = { colspan: "99" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_content = _resolveComponent("editor-content")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (announcement) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: announcement.AnnouncementID
          }, [
            _createElementVNode("td", null, _toDisplayString(announcement.LocationDisplayName), 1 /* TEXT */),
            _createElementVNode("td", {
              innerHTML: announcement.Copy
            }, null, 8 /* PROPS */, _hoisted_6),
            _createElementVNode("td", null, _toDisplayString(announcement.DateEndingDisplay), 1 /* TEXT */),
            _createElementVNode("td", {
              style: {"cursor":"pointer"},
              onClick: ($event: any) => (_ctx.remove(announcement))
            }, " × ", 8 /* PROPS */, _hoisted_7)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.announcements.length <= 0 && _ctx.loaded)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
          : _createCommentVNode("v-if", true),
        (!_ctx.innactiveAnnouncementsLoaded)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", {
                  style: {"text-align":"center","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadAnnouncements(true)))
                }, " Load In-Active Announcements ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("tbody", null, [
        (!_ctx.isAddEditing)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
              _createElementVNode("td", {
                colspan: "99",
                style: {"text-align":"center","cursor":"pointer"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startAdding && _ctx.startAdding(...args)))
              }, " Add announcement ")
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.isAddEditing)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_14, _hoisted_16))
        : _createCommentVNode("v-if", true),
      (_ctx.isAddEditing)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAnnouncement.Space.SpaceID) = $event)),
                  name: "tl-announcement-add-space"
                }, [
                  _hoisted_18,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaces, (space) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: space.SpaceID,
                      value: space.SpaceID
                    }, _toDisplayString(space.SpaceName), 9 /* TEXT, PROPS */, _hoisted_19))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.newAnnouncement.Space.SpaceID]
                ])
              ]),
              _createElementVNode("td", _hoisted_20, [
                (_ctx.editor)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bold') }),
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.editor.chain().focus().toggleBold().run()), ["prevent"]))
                      }, " B ", 2 /* CLASS */),
                      _createElementVNode("button", {
                        class: _normalizeClass({ 'is-active': _ctx.editor.isActive('italic') }),
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.editor.chain().focus().toggleItalic().run()), ["prevent"]))
                      }, " I ", 2 /* CLASS */),
                      (!_ctx.editor.view.state.selection.empty)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('link') }),
                            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setLink && _ctx.setLink(...args)), ["prevent"]))
                          }, " Add link ", 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.editor.isActive('link'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: !_ctx.editor.isActive('link'),
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.editor.chain().focus().unsetLink().run()), ["prevent"]))
                          }, " Remove link ", 8 /* PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.editor)
                  ? (_openBlock(), _createBlock(_component_editor_content, {
                      key: 1,
                      editor: _ctx.editor
                    }, null, 8 /* PROPS */, ["editor"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("td", _hoisted_23, [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.newAnnouncement.DateEnding,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newAnnouncement.DateEnding) = $event)),
                  format: "yyyy/MM/dd",
                  "enable-time-picker": false,
                  "min-date": new Date(),
                  "show-now-button": true,
                  "now-button-label": "Today",
                  clearable: false
                }, null, 8 /* PROPS */, ["modelValue", "min-date"])
              ]),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", {
                  class: "btn",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateAndAdd && _ctx.validateAndAdd(...args)))
                }, " Add ")
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}